export default __webpack_public_path__ + "static/media/asta-18855.346bb285.png";